import { render, staticRenderFns } from "./BmapScatter.vue?vue&type=template&id=89affcc0&scoped=true&"
import script from "./BmapScatter.vue?vue&type=script&lang=js&"
export * from "./BmapScatter.vue?vue&type=script&lang=js&"
import style0 from "./BmapScatter.vue?vue&type=style&index=0&id=89affcc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89affcc0",
  null
  
)

export default component.exports